import { isPostcodeFormatValid } from '@/helpers/PostcodeHelpers';
import PostcodeService from '@/services/logistics/PostcodeService';

/**
 * Check if postcode is valid.
 *
 * @param {String} postcode
 *
 * @returns {Boolean}
 */
export const isValidPostcode = (postcode) => {
    return isPostcodeFormatValid(postcode);
};

/**
 * Check if we deliver to this postcode
 *
 * @param {String} postcode
 *
 * @returns {Boolean}
 */
export const isPostcodeDeliverable = (postcode) => {
    return (new PostcodeService()).isPostcodeDeliverable(postcode);
};
